"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSantanderProductTypeFromFinancingType = exports.getSantanderApplicantTypeFromCustomerType = exports.SantanderProductType = exports.SantanderApplicantType = exports.CustomerInformationResponseStatus = exports.R35Status = exports.ApplicationResultCode = void 0;
const customer_1 = require("./customer");
const financing_1 = require("./financing");
var ApplicationResultCode;
(function (ApplicationResultCode) {
    ApplicationResultCode["NEW_CASE"] = "New case";
    ApplicationResultCode["APPROVED"] = "Approved";
    ApplicationResultCode["CONTROL"] = "Control";
    ApplicationResultCode["DOCUMENTS_GENERATED"] = "Documents generated";
    ApplicationResultCode["DOCUMENTS_APPROVED"] = "Documents approved";
    ApplicationResultCode["DISBURSED"] = "Disbursed";
    ApplicationResultCode["REJECTED"] = "Rejected";
    ApplicationResultCode["CANCELLED"] = "Cancelled";
})(ApplicationResultCode = exports.ApplicationResultCode || (exports.ApplicationResultCode = {}));
var R35Status;
(function (R35Status) {
    R35Status["NOT_APPLICABLE"] = "Not Applicable";
    R35Status["SMS_SENT"] = "Sms sent";
    R35Status["SMS_NOT_SENT"] = "Sms not sent";
})(R35Status = exports.R35Status || (exports.R35Status = {}));
var CustomerInformationResponseStatus;
(function (CustomerInformationResponseStatus) {
    CustomerInformationResponseStatus["SENT"] = "Sent";
    CustomerInformationResponseStatus["ANSWERED"] = "Answered";
    CustomerInformationResponseStatus["FAILED"] = "Failed";
})(CustomerInformationResponseStatus = exports.CustomerInformationResponseStatus || (exports.CustomerInformationResponseStatus = {}));
var SantanderApplicantType;
(function (SantanderApplicantType) {
    SantanderApplicantType["PRIVATE"] = "Private";
    SantanderApplicantType["COMPANY"] = "Company";
})(SantanderApplicantType = exports.SantanderApplicantType || (exports.SantanderApplicantType = {}));
var SantanderProductType;
(function (SantanderProductType) {
    SantanderProductType["LOAN"] = "Loan";
    SantanderProductType["LEASING"] = "Leasing";
})(SantanderProductType = exports.SantanderProductType || (exports.SantanderProductType = {}));
const getSantanderApplicantTypeFromCustomerType = (customerType) => {
    switch (customerType) {
        case customer_1.CustomerType.BUSINESS:
            return SantanderApplicantType.COMPANY;
        default:
            return SantanderApplicantType.PRIVATE;
    }
};
exports.getSantanderApplicantTypeFromCustomerType = getSantanderApplicantTypeFromCustomerType;
const getSantanderProductTypeFromFinancingType = (financingType) => {
    switch (financingType) {
        case financing_1.FinancingType.LEASING:
            return SantanderProductType.LEASING;
        case financing_1.FinancingType.LOAN:
        default:
            return SantanderProductType.LOAN;
    }
};
exports.getSantanderProductTypeFromFinancingType = getSantanderProductTypeFromFinancingType;
//# sourceMappingURL=santander.js.map